import { RootStore } from "../../../store/rootStore.js";
const bridgeRegistry = new WeakMap();
function resolveAttachmentsBrowserController(attachmentsBrowser) {
    if (!attachmentsBrowser) {
        return undefined;
    }
    return attachmentsBrowser.controller;
}
function getRmlMediaBridge(attachmentsBrowser) {
    const controller = resolveAttachmentsBrowserController(attachmentsBrowser);
    if (!controller) {
        return undefined;
    }
    return bridgeRegistry.get(controller) ?? controller.rmlMediaBridge;
}
function getDefaultTreeStore() {
    return RootStore.get.treeStore;
}
function resolveTreeStore(attachmentsBrowser) {
    return getRmlTreeStore(attachmentsBrowser) ?? getDefaultTreeStore();
}
function getRmlTreeStore(attachmentsBrowser) {
    return resolveAttachmentsBrowserController(attachmentsBrowser)?.rmlTreeStore;
}
function setRmlMediaBridge(attachmentsBrowser, bridge, treeStore) {
    const controller = resolveAttachmentsBrowserController(attachmentsBrowser);
    if (!controller) {
        return;
    }
    bridgeRegistry.set(controller, bridge);
    controller.rmlMediaBridge = bridge;
    controller.rmlTreeStore = treeStore;
}
function clearRmlMediaBridge(attachmentsBrowser) {
    const controller = resolveAttachmentsBrowserController(attachmentsBrowser);
    if (!controller) {
        return;
    }
    bridgeRegistry.delete(controller);
    delete controller.rmlMediaBridge;
    delete controller.rmlTreeStore;
}
export { clearRmlMediaBridge, getDefaultTreeStore, getRmlMediaBridge, getRmlTreeStore, resolveTreeStore, setRmlMediaBridge };
